import { trapFocus } from './helpers.js'
import { GTM_addToCart, GTM_modifyCartAdd, GTM_removeFromCart } from './Gtm.js'

const cartPanelInner = document.querySelector('[data-mini-cart-panel-inner]')
const cartCountWraps = document.querySelectorAll('[data-cart-count-wrap]')
const cartCounts = document.querySelectorAll('[data-cart-count]')

export const getCart = (callback = null, buttonElement = null) => {
  fetch(`${window.routes.cart_url}?view=inline`)
    .then((response) => response.text())
    .then((cartResponse) => {
      cartPanelInner.innerHTML = new DOMParser()
        .parseFromString(cartResponse, 'text/html')
        .querySelector('[data-inline-cart]').innerHTML
      const cart = JSON.parse(cartPanelInner.querySelector('[data-cart-json]').innerHTML)
      if (buttonElement) {
        const innerHTML = buttonElement.innerHTML
        buttonElement.innerHTML = 'Item Added'
        setTimeout(() => {
          buttonElement.innerHTML = innerHTML
          buttonElement.disabled = false
        }, 2000)
      }
      cartPanelInner.classList.remove('mini-cart--transition')
      cartCountWraps.forEach((cartCountWrap) => cartCountWrap.classList.toggle('!hidden', cart.item_count == 0))
      cartCounts.forEach((cartCount) => (cartCount.innerHTML = cart.item_count))

      if (cart.item_count > 0) window.updateRecentProducts()

      trapFocus(document.querySelector('[data-mini-cart-close]'), cartPanelInner.querySelector('[data-last-inlnie-cart-element]'))

      if (callback) callback(cart)
    })
    .catch((e) => {
      console.error(e)
    })
}
window.getCart = getCart

export const addLineItems = (callback = null, items = [], buttonElement = null) => {
  cartPanelInner.classList.add('mini-cart--transition')
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      items: items,
    }),
  })
    .then((response) => {
      return response.json()
    })
    .then((response) => {
      console.log(response)
      GTM_addToCart(response,items, buttonElement)
      getCart(callback, buttonElement)
    })
    .catch((error) => {
      console.error('Error:', error)
      getCart(callback, buttonElement)
    })
}
window.addLineItems = addLineItems

export const changeLineItem = (callback = null, item = {}, additionalData = {}) => {
  console.log('changeLineItem', item, additionalData)
  cartPanelInner.classList.add('mini-cart--transition')
  fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(item),
  })
    .then((response) => {
      return response.json()
    })
    .then((cart) => {
      console.log(cart)
      if(additionalData?.type === 'update_variant') {
        if(item.quantity > additionalData?.prevQuantity) GTM_modifyCartAdd(cart)
        if(item.quantity < additionalData?.prevQuantity) GTM_removeFromCart(cart)
      } else if(additionalData?.type === 'remove_from_cart') {
        GTM_removeFromCart(cart)
      }
      setTimeout(() => {
        getCart(callback)
      }, 500);
    })
    .catch((error) => {
      console.error('Error:', error)
      getCart(callback)
    })
}
window.changeLineItem = changeLineItem

export const updateAdditional = (callback = null, data = {}, renderDrawer = false) => {
  cartPanelInner.classList.add('mini-cart--transition')
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .then((cart) => {
      console.log(cart)
      if (renderDrawer) {
        getCart(callback)
      } else {
        if (callback) callback(cart)
      }
    })
    .catch((error) => {
      console.error('Error:', error)
      getCart(callback)
    })
}
window.updateAdditional = updateAdditional
